import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { Page404 } from '../pages/Page404'
import { Register } from '../pages'
import { Success } from '../pages/Success'
import { Validation } from '../pages/Validation'
import { ListInfos } from '../pages/ListInfos'
import { VerifyValidation } from '../pages/VerifyValidation'

export const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Register} />
        <Route exact path="/validar-codigo" component={Validation} />
        <Route exact path="/verificar-validacao" component={VerifyValidation} />
        <Route exact path="/admin/listar" component={ListInfos} />
        <Route exact path="/cadastro-realizado" component={Success} />
        <Route path="*" component={Page404} />
      </Switch>
    </BrowserRouter>
  )
}
